var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQuestion28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.5 4C8.701 4 4 8.701 4 14.5S8.701 25 14.5 25 25 20.299 25 14.5 20.299 4 14.5 4ZM3 14.5C3 8.149 8.149 3 14.5 3S26 8.149 26 14.5 20.851 26 14.5 26 3 20.851 3 14.5Zm11.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12.556 9.517c.917-.405 1.967-.58 2.874-.496.919.086 1.594.427 1.915.947.686 1.11.286 2.492-1.127 3.69-1.49 1.263-2.217 2.088-2.217 3.342a.5.5 0 1 0 1 0c0-.746.355-1.3 1.864-2.58 1.587-1.345 2.395-3.255 1.331-4.978-.554-.896-1.597-1.315-2.673-1.416-1.088-.103-2.309.107-3.371.577a.5.5 0 0 0 .404.914Z",
  clipRule: "evenodd"
})));
export { SvgQuestion28 as ReactComponent };
export default __webpack_public_path__ + "44a4dac4489eacdfeaf22cc82fc51446.svg";